export const SET_PAYMENTS_HISTORY = 'SET_PAYMENTS_HISTORY'
export const RESET_HISTORY_PAYMENTS = 'RESET_HISTORY_PAYMENTS'
export const SET_RESPONSE_ID = 'SET_RESPONSE_ID'
